'use strict';

import env from 'env';

export const BASE_PATH = env.API_URL.replace(/\/+$/, "");
